import { useCallback } from 'react';
import tagularEvent from '../utils/tagularEvent';
import { getFullOptionsFromFlowState } from '../utils/dataFromFlowUtils';
import type { FlowState } from '../providers/dynamicExperienceReducer';
import { uuid } from '@de/shared/utils';
import type { Option } from '../types/types';

export const useIdentifyEvent = () => {
  const triggerIdentify = useCallback(
    (
      flowState: FlowState,
      dcsData?: {
        degree?: Option;
        category?: Option;
        subject?: Option;
      },
    ) => {
      const email =
        (getFullOptionsFromFlowState('email', flowState)?.value as string) ||
        '';
      const firstName =
        (getFullOptionsFromFlowState('firstName', flowState)
          ?.value as string) || '';

      const traits = {
        email,
        firstName,
        // storing the dcs query parameters in the website property to add to the CTA in the email so they have their dcs when they return
        website: `dcs[degrees][]=${dcsData?.degree?.text || ''}&dcs[categories][]=${dcsData?.category?.text || ''}&dcs[subjects][]=${dcsData?.subject?.text || ''}`,
      };

      tagularEvent('Identify', {
        traits,
        anonymousId: (window as any)?._Cohesion?.anonymousId || '',
        correlationId: uuid(),
      });
    },
    [],
  );

  return {
    triggerIdentify,
  };
};
